// pH Lab Hair · Brush Hair LP ortak davranışları
(function(){
  var LIVE = /(^|\.)phlabhair\.com$|(^|\.)phlabofficial\.com$|myshopify\.com$/.test(location.hostname);
  var STORE = LIVE ? '' : 'https://phlabofficial.com';
  // Gerçek varyant id'leri ve fiyatlar (phlabhair.com/products.json, 22 Eyl 2026)
  var V = {
    kadin: [
      {id:54243689562406, qty:1, title:'1 Adet', sub:'1 aylık kullanım', price:1099, was:1391},
      {id:54243689595174, qty:3, title:'3 Adet', sub:'3 al 2 öde + %10 · tanesi 659\u00a0₺', price:1978, was:3297, flag:'En çok tercih edilen'},
      {id:54243689627942, qty:6, title:'6 Adet', sub:'6 al 4 öde + %20 · tanesi 586\u00a0₺', price:3516, was:6594, flag:'Ekonomik paket'}
    ],
    erkek: [
      {id:54243690610982, qty:1, title:'1 Adet', sub:'1 aylık kullanım', price:1099, was:1391},
      {id:54243690643750, qty:3, title:'3 Adet', sub:'3 al 2 öde + %10 · tanesi 659\u00a0₺', price:1978, was:3297, flag:'En çok tercih edilen'},
      {id:54243690676518, qty:6, title:'6 Adet', sub:'6 al 4 öde + %20 · tanesi 586\u00a0₺', price:3516, was:6594, flag:'Ekonomik paket'}
    ]
  };
  var fmt = function(n){ return n.toLocaleString('tr-TR') + '\u00a0₺'; };

  // Satın alma kutusu: <div class="buybox" data-buy data-gender="kadin|erkek" data-toggle="1" data-default="1">
  document.querySelectorAll('[data-buy]').forEach(function(box, bi){
    var g = box.getAttribute('data-gender') || 'kadin';
    var def = +(box.getAttribute('data-default') || 1);
    var list = box.querySelector('.packs');
    var btn = box.querySelector('[data-cart]');
    var total = box.querySelector('[data-total]');
    function render(){
      list.innerHTML = V[g].map(function(p, i){
        var id = 'pk' + bi + '-' + i;
        return '<label class="pack" for="' + id + '">' + (p.flag ? '<span class="pack-flag">' + p.flag + '</span>' : '') +
          '<input type="radio" name="pk' + bi + '" id="' + id + '" value="' + i + '"' + (i === def ? ' checked' : '') + '>' +
          '<span><span class="pack-title">' + p.title + '</span><br><span class="pack-sub">' + p.sub + '</span></span>' +
          '<span class="pack-price"><s>' + fmt(p.was) + '</s>' + fmt(p.price) + '</span></label>';
      }).join('');
      update();
    }
    function update(){
      var i = +(list.querySelector('input:checked') || {value:def}).value; def = i;
      var p = V[g][i];
      if (btn) btn.href = STORE + '/cart/' + p.id + ':1';
      if (total) total.textContent = fmt(p.price);
    }
    list.addEventListener('change', update);
    box.querySelectorAll('.gender button').forEach(function(b){
      b.addEventListener('click', function(){
        g = b.getAttribute('data-g');
        box.querySelectorAll('.gender button').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        box.querySelectorAll('[data-show-g]').forEach(function(el){ el.hidden = el.getAttribute('data-show-g') !== g; });
        render();
      });
    });
    render();
  });

  // Mağazada /cart/ID:ADET linklerini sepete ekle + /cart'a git
  if (LIVE) document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var m = a.getAttribute('href').match(/\/cart\/(\d+:\d+(?:,\d+:\d+)*)$/); if (!m) return;
    e.preventDefault();
    var items = m[1].split(',').map(function(x){ var p = x.split(':'); return {id:+p[0], quantity:+p[1]}; });
    a.setAttribute('aria-busy','true');
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){
        if (!r.ok) throw 0;
        a.removeAttribute('aria-busy');
        if (document.getElementById('cdDrawer')) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else location.href = '/cart';
      })
      .catch(function(){ location.href = a.href; });
  });

  // Yatay kaydırma okları: <div class="rail" id="x"> + <div class="rail-nav" data-rail="x">
  document.querySelectorAll('[data-rail]').forEach(function(nav){
    var rail = document.getElementById(nav.getAttribute('data-rail'));
    if (!rail) return;
    nav.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var step = rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 14 : 300;
        rail.scrollBy({left: (b.getAttribute('data-dir') === 'prev' ? -1 : 1) * step, behavior: 'smooth'});
      });
    });
  });

  // Taslak notları aç/kapa (yayındaki sayfada not yok, düğme de yok)
  if (!document.querySelector('.note')) return;
  var t = document.createElement('button');
  t.className = 'notes-toggle'; t.type = 'button';
  var set = function(off){ document.body.classList.toggle('notes-off', off); t.textContent = off ? 'Notları göster' : 'Notları gizle'; };
  t.addEventListener('click', function(){ set(!document.body.classList.contains('notes-off')); });
  document.body.appendChild(t); set(false);
})();
